import { render } from "./multipleChoicesQuestion.vue?vue&type=template&id=670305ba&scoped=true"
import script from "./multipleChoicesQuestion.vue?vue&type=script&lang=js"
export * from "./multipleChoicesQuestion.vue?vue&type=script&lang=js"

import "./multipleChoicesQuestion.vue?vue&type=style&index=0&id=670305ba&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-670305ba"]])

export default __exports__